import { render, staticRenderFns } from "./WLogin.vue?vue&type=template&id=b53940ce&scoped=true"
import script from "./WLogin.vue?vue&type=script&lang=js"
export * from "./WLogin.vue?vue&type=script&lang=js"
import style0 from "./WLogin.vue?vue&type=style&index=0&id=b53940ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53940ce",
  null
  
)

export default component.exports